import React, { Component, useState, useEffect } from 'react'
import '../styles/ActivityList.css'
import xButton from '../images/x-white.png'
import OverlayForm from '../widgets/OverlayForm'
import APICalendar from '../api/APICalendar'
import ActivityDetails from './ActivityDetails'

class ActivityList extends Component
{
	constructor(props) {
		super(props)
		const m = APICalendar.getMonthString(props.cMonth)
		this.state = {
			title: m + " " + props.cDate
		}
		this.viewDetails = this.viewDetails.bind(this)
		this.onSignal = this.onSignal.bind(this)
	}

	componentDidUpdate(prevProps) {
		if(prevProps.show != this.props.show) {
			const items = [];
			for(const v of this.props.activities) {
				items.push(<ListItem data={v} viewDetails={this.viewDetails} />)
			}
			let bc
			switch(this.props.status) {
				case 1: // current month
					bc = "#ffffff"
					break
				case 2: //"attention":
					bc = "#c96f6f"
					break
				case 3: // done
					bc = "#9d9d9d"
					break
				case 4: //"happening":
					bc = "#a9be3d"
					break
				case 5: //"upcoming":
					bc = "#ddbc33"
					break
				default:
					bc = "#f4f4f4"
			}
			this.setState({
				listItems: items,
				bgColor: bc,
				cHeight: (this.props.show)? "100%": "0%"
			});
		}
	}

	viewDetails(data) {
		this.setState({
			details: data,
			show: true
		})
	}

	onSignal(view, id, stat) {
		this.props.onSignal(view, id, stat)
	}

	render() {
		const c = <div id="activity-list">
			{this.props.show && <div id={"act-list-header"} style={{background: this.state.bgColor}}>
				<div id="act-list-title">{this.state.title} ACTIVITIES</div>
				<div id="act-list-close">
					<img src={xButton} id="x-button" alt="Close" onClick={() => {
						this.props.hide()
					}} />
				</div>
			</div>}
			{this.props.show && <div id={"act-list-content"}>{this.state.listItems}</div>}
		</div>
		return(<div className="activity-list">
			<OverlayForm content={c} cHeight={this.state.cHeight} isForm={true} top='200px' left='50%' />
			<ActivityDetails show={this.state.show}
				hide={() => { this.setState({show: false})}}
				onSignal={this.onSignal}
				data={this.state.details} dateString={this.props.dateString} />
		</div>)
	}
}

function ListItem(props) {
	const data = props.data
	return(<div className="activity-listitem" onClick={() => {props.viewDetails(data)}}>
		{props.data.activity_title.toUpperCase()}, {props.data.start_time} - {props.data.end_time}
	</div>)
}

export default ActivityList
